angular.module('Itao.IndicatorMap').directive('chartDistrictLegend', function (d3, mapConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'chartDistrictLegend.html',
    scope: {
      districts: '=',
      districtColorFunction: '=',
      selectedDistricts: '=',
      disabledDistricts: '='
    },
    link: function(scope) {

      scope.isSelected = function(districtkey) {

        return (scope.selectedDistricts.map(function(d) {
          return d.key;
        }).indexOf(districtkey) !== -1);
      };

      /**
       * toggle one indicator of the currently selected indicators
       *
       * @param {String} districtKey the indicator to toggle
       */
      scope.toggleDistrict = function(districtKey) {
        var index = scope.disabledDistricts.indexOf(districtKey);
        if(index > -1) {
          scope.disabledDistricts.splice(index, 1);
        } else {
          scope.disabledDistricts.push(districtKey);
        }
      };
    }
  };
});
